const SUITS = ['H', 'D', 'C', 'S'];
const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

const CARD_VALUES = {
  'A': 1, '2': -2, '3': 3, '4': 4, '5': 5, '6': 6,
  '7': 7, '8': 8, '9': 9, '10': 10, 'J': 10, 'Q': 10, 'K': 0,
};

const SUIT_SYMBOLS = {
  'H': '♥', 'D': '♦', 'C': '♣', 'S': '♠',
};

const SUIT_COLORS = {
  'H': 'red', 'D': 'red', 'C': 'black', 'S': 'black',
};

function createDeck() {
  const deck = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push({ suit, rank });
    }
  }
  return deck;
}

function shuffleDeck(deck) {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function calculateHandScore(hand) {
  let total = 0;
  for (let col = 0; col < 3; col++) {
    const top = hand[col];
    const bottom = hand[col + 3];
    if (top.rank === bottom.rank) {
      continue;
    }
    total += CARD_VALUES[top.rank] + CARD_VALUES[bottom.rank];
  }
  return total;
}

function getCardValue(rank) {
  return CARD_VALUES[rank];
}

function getCardDisplay(card) {
  if (!card || card.rank === 'HIDDEN') {
    return { rank: '?', suit: '', color: 'black' };
  }
  return {
    rank: card.rank,
    suit: SUIT_SYMBOLS[card.suit],
    color: SUIT_COLORS[card.suit],
  };
}

function isHandComplete(hand) {
  return hand.every(card => card.faceUp);
}

export {
  SUITS,
  RANKS,
  CARD_VALUES,
  SUIT_SYMBOLS,
  SUIT_COLORS,
  createDeck,
  shuffleDeck,
  calculateHandScore,
  getCardValue,
  getCardDisplay,
  isHandComplete,
};
